var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpriteSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 544.87c-.053.001-.105.003-.159.003a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.004-.069-.004-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-928.4 415.09H900.255V-528.3H-928.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -6.055 -47.829)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 64.726 72.292)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.072-.006-.109-.006-.949 8.504-8.158 15.116-16.915 15.116-6.915 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 776.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M922.177 544.87c-.053.001-.105.003-.159.003a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.004-.069-.004-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.31"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.003-.003h96v96h-96z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.003-.003h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "drizzle"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 756.455 219.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(23 0 0 -23 739.955 211.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 766.455 211.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 756.455 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(23 0 0 -23 739.955 211.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 766.455 211.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M776.833 228.252c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.663-10.664 10.663c-.037 0-.073-.005-.11-.005-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.53-10.048-.083.002-.166.006-.251.006-7.29 0-13.198-5.909-13.198-13.198 0-7.289 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -964.217 364.43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.004.003h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "error",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.199 93.438c-23.977-24.003-48.007-47.954-71.95-71.99-2.724-3.134-.445-7.032 2.273-9.173C7.38 8.517 11.048 4.545 15.027.925c3.308-2.351 6.788.22 8.924 2.787 23.28 23.306 46.613 46.56 69.859 69.899 2.724 3.134.445 7.032-2.273 9.173-3.857 3.758-7.526 7.73-11.504 11.35-2.081 1.42-5.085 1.11-6.834-.696zm-59.024 0c-4.39-4.491-8.997-8.792-13.25-13.405-2.351-3.308.22-6.788 2.787-8.924 23.306-23.28 46.561-46.614 69.9-69.86 3.134-2.724 7.032-.445 9.173 2.273 3.758 3.858 7.73 7.526 11.35 11.505 2.351 3.308-.22 6.788-2.787 8.924-23.306 23.28-46.561 46.614-69.9 69.86-2.067 1.756-5.397 1.579-7.273-.373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.38,
    d: "M-.47-.47h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "drizzlethunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 -918.328 366.326)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.002 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.002 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 528.494c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.664-10.664 10.664c-.037 0-.072-.005-.11-.006-.948 8.504-8.157 15.117-16.914 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.29 0-13.198-5.909-13.198-13.198 0-7.29 5.909-13.199 13.198-13.199"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.002 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -983.994 356.326)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -977.328 366.326)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -923.662 356.326)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.003.002h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "fog"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1073.667 703.639H754.989V-239.75h-1828.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1084.486 701.463H744.17v-943.388h-1828.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1072.923 690.424H755.733v-943.388h-1828.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1091.598 694.116H737.058v-943.388h-1828.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1053.118 707.442H775.538v-943.388h-1828.656z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1059.747 699.866H768.909v-943.388h-1828.656z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 37.765 47.735)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0e8f8",
    d: "M0 0c0-7.487-6.07-13.557-13.558-13.557-7.487 0-13.557 6.07-13.557 13.557 0 7.488 6.07 13.558 13.557 13.558C-6.07 13.558 0 7.488 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 28.926 57.835)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0c0 6.852 5.555 12.406 12.407 12.406S24.813 6.852 24.813 0c0-6.853-5.554-12.407-12.406-12.407S0-6.853 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 80.232 40.068)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0c0-5.808-4.708-10.517-10.517-10.517-5.807 0-10.516 4.709-10.516 10.517s4.709 10.517 10.516 10.517C-4.708 10.517 0 5.808 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 55.333 35.145)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0e8f8",
    d: "M0 0c0-5.601-4.541-10.142-10.142-10.142-5.601 0-10.141 4.541-10.141 10.142 0 5.602 4.54 10.142 10.141 10.142S0 5.602 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 70.75 49.864)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0a8.864 8.864 0 0 1 8.865-8.864A8.863 8.863 0 0 1 17.729 0 8.865 8.865 0 0 1 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 56.325 52.765)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0e8f8",
    d: "M0 0a8.865 8.865 0 1 0 17.73 0A8.865 8.865 0 0 0 0 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.006-.003h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysleetsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -974.87 559.814)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#647179",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 977.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.105 690.6c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.073-.006-.11-.006-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.29 0-13.198-5.91-13.198-13.198 0-7.29 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 977.92)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "drizzlethundersun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -918.328 369.135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.002 764.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.002 764.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.002 764.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 528.494c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.664-10.664 10.664c-.037 0-.072-.005-.11-.006-.948 8.504-8.157 15.117-16.914 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.29 0-13.198-5.909-13.198-13.198 0-7.29 5.909-13.199 13.198-13.199"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.002 764.69)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -983.994 359.135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -977.328 369.135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "matrix(1.33333 0 0 -1.33333 -923.662 359.135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .004h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysleetthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-928.4 715.077H900.255V-228.31H-928.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053 0-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -1772.028 975.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -350.877 758.613)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#647179",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 65.92 59.881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.005-.253.005-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d2e9f8",
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1171.947 364.295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -1158.735 367.152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1787.028 975.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1723.028 975.367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysleet"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#647179",
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.105 690.6c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.073-.006-.11-.006-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.29 0-13.198-5.91-13.198-13.198 0-7.29 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "drizzlesun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 756.455 219.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(23 0 0 -23 739.955 211.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 766.455 211.454)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "matrix(13 0 0 -13 739.955 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 756.455 219.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(23 0 0 -23 739.955 211.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(18 0 0 -18 766.455 211.454)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M741.455 220.954a1.5 1.5 0 1 1 0-3h10a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M757.955 220.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M741.455 212.954a1.5 1.5 0 1 1 0-3h20a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -969.94 367.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M767.955 212.954a1.5 1.5 0 0 1-1.501-1.5c0-.828.673-1.5 1.501-1.5h15a1.5 1.5 0 1 1 0 3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 369.335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 369.335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M928.4 228.31c5.89 0 10.664 4.775 10.664 10.665 0 5.89-4.775 10.664-10.664 10.664-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.005-.253.005-7.289 0-13.198-5.91-13.198-13.198 0-7.29 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 369.335)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysleetthundersun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882h-.159a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392h-.069c-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.198 765.869)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1772.028 979.657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -350.877 762.903)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#647179",
    d: "M65.92 64.171c7.853 0 14.22-6.365 14.22-14.218 0-7.854-6.367-14.22-14.22-14.22-.049 0-.095.008-.145.009-1.265-11.339-10.877-20.156-22.553-20.156-9.22 0-17.152 5.501-20.704 13.397-.113-.001-.224-.006-.337-.006-9.719 0-17.598 7.878-17.598 17.597 0 9.719 7.879 17.597 17.598 17.597"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d2e9f8",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1171.947 368.585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1158.735 371.442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -1787.028 979.657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1723.028 979.657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysnowsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -970.237 565.474)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#647179",
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -560.176 561.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -554.32 567.737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -578.538 553.737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -583.571 544.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -549.571 558.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -538.571 544.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightrainsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M928.4 228.31c5.89 0 10.664 4.775 10.664 10.665 0 5.89-4.775 10.664-10.664 10.664-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.005-.253.005-7.289 0-13.198-5.91-13.198-13.198 0-7.29 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysnow"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 3.909 -36.244)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 3.909 -36.244)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M770.609 244.823c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.004-.069-.004-.596 5.34-5.122 9.492-10.621 9.492-4.343 0-8.078-2.591-9.751-6.31"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#647179",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -565.008 561.077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -559.293 567.541)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -583.51 553.541)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -588.544 544.225)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -554.544 558.225)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -543.544 544.225)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -972.911 361.395)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M770.609 244.823c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.004-.069-.004-.596 5.34-5.122 9.492-10.621 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightcloud"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(40.91009 -40.91009) rotate(-45 -.164 -31.228)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(40.91009 -40.91009) rotate(-45 -.164 -31.228)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.401 393.404c0-11.296 9.157-20.454 20.455-20.454 11.297 0 20.455 9.158 20.455 20.454 0 11.298-9.158 20.456-20.455 20.456-11.298 0-20.455-9.158-20.455-20.456"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M770.609 244.823c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.004-.069-.004-.596 5.34-5.122 9.492-10.621 9.492-4.343 0-8.078-2.591-9.751-6.31"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 572.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M895.401 393.404c0-11.296 9.157-20.454 20.455-20.454 11.297 0 20.455 9.158 20.455 20.454 0 11.298-9.158 20.456-20.455 20.456-11.298 0-20.455-9.158-20.455-20.456"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 -975.939 376.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M770.609 244.823c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.004-.069-.004-.596 5.34-5.122 9.492-10.621 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysnowthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882h-.159a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392h-.069c-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -351.06 756.89)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#647179",
    d: "M65.739 58.158c7.852 0 14.218-6.365 14.218-14.219 0-7.853-6.366-14.218-14.218-14.218-.05 0-.096.006-.146.008C64.328 18.389 54.716 9.573 43.04 9.573c-9.22 0-17.152 5.5-20.704 13.397-.113-.001-.224-.007-.337-.007-9.72 0-17.598 7.879-17.598 17.598 0 9.718 7.879 17.597 17.598 17.597"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d2e9f8",
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -1172.129 362.572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -571.585 566.48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -595.802 552.48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -600.835 543.165)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -540.835 557.165)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -529.835 543.165)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsleetsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -974.87 559.814)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 977.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.105 690.6c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.073-.006-.11-.006-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.29 0-13.198-5.91-13.198-13.198 0-7.29 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 977.92)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.002.004h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "heavysnowthundersun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882h-.159a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392h-.069c-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.38 764.145)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -351.06 761.18)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#647179",
    d: "M65.739 62.448c7.852 0 14.218-6.365 14.218-14.219 0-7.853-6.366-14.218-14.218-14.218-.05 0-.096.006-.146.008-1.265-11.34-10.877-20.156-22.553-20.156-9.22 0-17.152 5.5-20.704 13.397-.113-.001-.224-.007-.337-.007-9.719 0-17.598 7.879-17.598 17.598 0 9.718 7.879 17.597 17.598 17.597"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d2e9f8",
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -1172.129 366.862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -571.585 570.77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -595.802 556.77)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -600.835 547.455)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "matrix(1.33333 0 0 -1.33333 -540.835 561.455)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "matrix(1.33333 0 0 -1.33333 -529.835 547.455)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightrainthundersun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -352.071 764.08)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M928.4 228.31c5.89 0 10.664 4.775 10.664 10.665 0 5.89-4.775 10.664-10.664 10.664-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.005-.253.005-7.289 0-13.198-5.91-13.198-13.198 0-7.29 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -1177.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "matrix(1.33333 0 0 -1.33333 -1165.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightrain"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 707.602c-.052 0-.104.003-.157.003a8.288 8.288 0 0 1 0-16.575h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.309"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.924 682.682l-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.035 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.147 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.923 675.503l-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.536 675.503l-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.147 675.503l-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -23.435 -25.199)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 283.769 679.183)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 299.88 679.183)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 315.993 679.183)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 288.769 672.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 305.381 672.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 321.993 672.003)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 691.03c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.072-.006-.11-.006-.948 8.504-8.157 15.116-16.914 15.116-6.915 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.29 0-13.198-5.91-13.198-13.198 0-7.29 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M315.904 707.602c-.052 0-.104.003-.157.003a8.288 8.288 0 0 1 0-16.575h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.309"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M286.924 682.682l-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M303.035 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M319.147 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M291.923 675.503l-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M308.536 675.503l-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M325.147 675.503l-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.002-.006h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightrainthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -352.071 764.08)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M928.4 228.31c5.89 0 10.664 4.775 10.664 10.665 0 5.89-4.775 10.664-10.664 10.664-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.005-.253.005-7.289 0-13.198-5.91-13.198-13.198 0-7.29 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -1177.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -1165.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsleet"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.105 690.6c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.073-.006-.11-.006-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.29 0-13.198-5.91-13.198-13.198 0-7.29 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsleetthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.004-.006h96v96h-96z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -372.778 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 528.494c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.664-10.664 10.664c-.037 0-.072-.005-.11-.006-.948 8.504-8.157 15.117-16.914 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.29 0-13.198-5.909-13.198-13.198 0-7.29 5.909-13.199 13.198-13.199"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1766.45 971.446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1782.45 971.446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsnow"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsnowthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 12.798 -57.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 12.798 -57.24)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1208.592 229.026l-5.267-9.123c-.825-1.428-.154-2.499 1.492-2.378l4.302.315c1.646.122 2.348-.965 1.56-2.415l-4.785-8.806c-.788-1.45-.39-1.778.884-.73l17.302 14.229c1.274 1.048.968 1.836-.679 1.752l-6.612-.338c-1.647-.084-2.32 1.016-1.496 2.445l2.91 5.04c.825 1.428.15 2.598-1.5 2.601h-3.611c-1.65 0-3.676-1.166-4.5-2.594"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1554.56 355.264)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1208.592 229.026l-5.267-9.123c-.825-1.428-.154-2.499 1.492-2.378l4.302.315c1.646.122 2.348-.965 1.56-2.415l-4.785-8.806c-.788-1.45-.39-1.778.884-.73l17.302 14.229c1.274 1.048.968 1.836-.679 1.752l-6.612-.338c-1.647-.084-2.32 1.016-1.496 2.445l2.91 5.04c.825 1.428.15 2.598-1.5 2.601l-3.611.002c-1.65.002-3.676-1.166-4.5-2.594"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -575.403 556.494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -588.62 556.494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -582.653 561.178)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsleetthundersun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -372.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 528.494c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.664-10.664 10.664c-.037 0-.072-.005-.11-.006-.948 8.504-8.157 15.117-16.914 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.29 0-13.198-5.909-13.198-13.198 0-7.29 5.909-13.199 13.198-13.199"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1766.45 973.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -1782.45 973.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsnowthundersun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882h-.159a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392h-.069c-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -352.071 757.932)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 363.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.726 59.2c7.852 0 14.219-6.365 14.219-14.219 0-7.853-6.367-14.218-14.219-14.218-.049 0-.096.006-.145.008-1.265-11.339-10.877-20.156-22.553-20.156-9.22 0-17.152 5.501-20.704 13.397-.114-.001-.224-.007-.338-.007-9.718 0-17.597 7.88-17.597 17.598S11.268 59.2 20.986 59.2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 363.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -574.403 560.346)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -560.62 567.346)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "matrix(1.33333 0 0 -1.33333 -577.653 564.03)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "rainsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M928.4 228.31c5.89 0 10.664 4.775 10.664 10.665 0 5.89-4.775 10.664-10.664 10.664-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.005-.253.005-7.289 0-13.198-5.91-13.198-13.198 0-7.29 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "partlycloud"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -2.364 -38.842)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -2.364 -38.842)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M770.609 394.18c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.576h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.003-.069-.004-.596 5.34-5.122 9.493-10.621 9.493-4.343 0-8.078-2.592-9.751-6.31"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -971.05 578.317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -971.05 578.317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M776.833 377.608c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.663-10.664 10.663c-.037 0-.073-.005-.11-.005-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.53-10.048-.083.002-.166.006-.251.006-7.29 0-13.198-5.909-13.198-13.198 0-7.289 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -971.05 578.317)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M770.609 394.18c-.052.001-.105.004-.159.004a8.288 8.288 0 0 1 0-16.576h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.045-.003-.069-.004-.596 5.34-5.122 9.493-10.621 9.493-4.343 0-8.078-2.592-9.751-6.31"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "rain"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(10.49946 0 0 -10.49946 1341.917 675.625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(14.00044 0 0 -14.00044 1349.057 672.593)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(10.00044 0 0 -10.00044 1373.838 676.057)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(12.00044 0 0 -12.00044 1361.947 674.325)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "matrix(10.49946 0 0 -10.49946 1341.917 675.625)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "matrix(14.00044 0 0 -14.00044 1349.057 672.593)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.105 690.6c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.073-.006-.11-.006-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.29 0-13.198-5.91-13.198-13.198 0-7.29 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.001-.003h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "sleetsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.924 682.682l-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.035 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.147 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.923 675.503l-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.536 675.503l-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.147 675.503l-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 765.511)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 765.511)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 528.494c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.664-10.664 10.664c-.037 0-.072-.005-.11-.006-.948 8.504-8.157 15.117-16.914 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.29 0-13.198-5.909-13.198-13.198 0-7.29 5.909-13.199 13.198-13.199"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 765.511)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.924 682.682l-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#i)",
    transform: "matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.035 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#j)",
    transform: "matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.147 682.682l-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#k)",
    transform: "matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.923 675.503l-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#l)",
    transform: "matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.536 675.503l-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#m)",
    transform: "matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.147 675.503l-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "lightsnowsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -970.237 565.474)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -560.176 561.515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -554.32 567.737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -578.538 553.737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -583.571 544.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -549.571 558.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -538.571 544.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "rainthundersun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 892.753 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 906.365 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 1,
    gradientTransform: "matrix(6.88767 0 0 -6.88767 920.977 216.465)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -352.071 764.08)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M928.4 228.31c5.89 0 10.664 4.775 10.664 10.665 0 5.89-4.775 10.664-10.664 10.664-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.005-.253.005-7.289 0-13.198-5.91-13.198-13.198 0-7.29 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M895.908 219.964l-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -1177.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M909.52 219.964l-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "matrix(1.33333 0 0 -1.33333 -1165.14 369.763)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M924.132 219.964l-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "sleetthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.004-.006h96v96h-96z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -372.778 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 528.494c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.664-10.664 10.664c-.037 0-.072-.005-.11-.006-.948 8.504-8.157 15.117-16.914 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.29 0-13.198-5.909-13.198-13.198 0-7.29 5.909-13.199 13.198-13.199"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 761.88)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1766.45 971.446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1782.45 971.446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "sleet"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -4.962 -69.747)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1383.105 690.6c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.073-.006-.11-.006-.948 8.504-8.157 15.116-16.914 15.116-6.916 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.29 0-13.198-5.91-13.198-13.198 0-7.29 5.909-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1348.684 682.253l-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.325 682.253l-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -1779.413 973.98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1370.216 682.253l-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "rainthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.362 691.713l-5.267-9.122c-.826-1.43-.154-2.5 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.047.969 1.837-.68 1.752l-6.61-.338c-1.648-.085-2.322 1.016-1.496 2.444l2.909 5.04c.825 1.429.15 2.599-1.5 2.601l-3.611.004c-1.65.001-3.675-1.168-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.041 707.141l-.159.003a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.124 9.493-10.622 9.493-4.342 0-8.077-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.844 682.311l-6.499-11.257a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600.478 682.311l-6.499-11.257a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -18.683 -39.395)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -18.143 -37.921)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "matrix(10.49946 0 0 -10.49946 583.077 675.683)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(10.49946 0 0 -10.49946 593.71 675.683)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M615.362 691.713l-5.267-9.122c-.826-1.43-.154-2.5 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.047.969 1.837-.68 1.752l-6.61-.338c-1.648-.085-2.322 1.016-1.496 2.444l2.909 5.04c.825 1.429.15 2.599-1.5 2.601l-3.611.004c-1.65.001-3.675-1.168-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M625.264 690.57c5.89 0 10.664 4.773 10.664 10.663 0 5.89-4.774 10.664-10.664 10.664-.037 0-.072-.006-.109-.006-.949 8.504-8.158 15.116-16.915 15.116-6.915 0-12.864-4.125-15.528-10.048-.084.002-.168.006-.252.006-7.29 0-13.199-5.909-13.199-13.198 0-7.289 5.91-13.198 13.2-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M619.041 707.141l-.159.003a8.288 8.288 0 0 1 0-16.575h20.6a6.696 6.696 0 1 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.124 9.493-10.622 9.493-4.342 0-8.077-2.591-9.751-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M589.844 682.311l-6.499-11.257a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -768.96 977.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M600.478 682.311l-6.499-11.257a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.733l6.499 11.256a2 2 0 0 1-.732 2.732 2 2 0 0 1-2.732-.732"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.004-.003h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "sleetsunthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -19.365 -25.284)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -16.61 -22.372)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -372.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M322.129 528.494c5.889 0 10.664 4.774 10.664 10.664s-4.775 10.664-10.664 10.664c-.037 0-.072-.005-.11-.006-.948 8.504-8.157 15.117-16.914 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.29 0-13.198-5.909-13.198-13.198 0-7.29 5.909-13.199 13.198-13.199"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -364.778 763.845)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1766.45 973.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -1782.45 973.41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1380.107 682.253l-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
  })))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "snowsun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 -3.576 -43.482)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -970.237 565.474)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -560.176 561.515)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -554.32 567.737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -578.538 553.737)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -583.571 544.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "matrix(1.33333 0 0 -1.33333 -549.571 558.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "matrix(1.33333 0 0 -1.33333 -538.571 544.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "snow"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "snowsunthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 -17.3 -22.364)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(25.92643 -25.92643) rotate(-45 6.2 -47.7)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 6.543 -42.61)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.177 244.882h-.159a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392h-.069c-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "matrix(1.33333 0 0 -1.33333 -352.071 757.932)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M299.226 529.637l-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 363.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.726 59.2c7.852 0 14.219-6.365 14.219-14.219 0-7.853-6.367-14.218-14.219-14.218-.049 0-.096.006-.145.008-1.265-11.339-10.877-20.156-22.553-20.156-9.22 0-17.152 5.501-20.704 13.397-.114-.001-.224-.007-.338-.007-9.718 0-17.597 7.88-17.597 17.598S11.268 59.2 20.986 59.2"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 363.614)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -574.403 560.346)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -560.62 567.346)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "matrix(1.33333 0 0 -1.33333 -577.653 564.03)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "wind"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(40.95254 0 0 -40.95254 1200.113 381.379)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(65.44842 0 0 -65.44842 1186.268 390.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x2: 1,
    gradientTransform: "matrix(30.30216 0 0 -30.30216 1210.764 405.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00bdf2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235.857 386.517c-.022.001-.043.007-.065.007h-34.081a1.598 1.598 0 0 1 0-3.196h29.453a5.114 5.114 0 0 1-.388-1.949 5.144 5.144 0 1 1 10.29 0 5.145 5.145 0 0 1-5.145 5.145c-.022 0-.043-.006-.064-.007"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.507 395.348c-.022 0-.043.007-.065.007h-58.577a1.598 1.598 0 0 1 0-3.195h53.95a5.104 5.104 0 0 1-.388-1.95 5.144 5.144 0 0 1 10.288 0 5.145 5.145 0 0 1-5.144 5.145c-.022 0-.042-.007-.064-.007"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1230.776 405.431c0-.691.141-1.348.388-1.95h-18.803a1.597 1.597 0 1 1 0-3.195h23.431c.022 0 .043.005.065.007.021 0 .042-.007.064-.007a5.145 5.145 0 0 1 0 10.29 5.146 5.146 0 0 1-5.145-5.145"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-.006 0h96v96h-96z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -1577.323 572.538)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1235.857 386.517c-.022.001-.043.007-.065.007h-34.081a1.598 1.598 0 0 1 0-3.196h29.453a5.114 5.114 0 0 1-.388-1.949 5.144 5.144 0 1 1 10.29 0 5.145 5.145 0 0 1-5.145 5.145c-.022 0-.043-.006-.064-.007"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(1.33333 0 0 -1.33333 -1577.323 572.538)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1246.507 395.348c-.022 0-.043.007-.065.007h-58.577a1.598 1.598 0 0 1 0-3.195h53.95a5.104 5.104 0 0 1-.388-1.95 5.144 5.144 0 0 1 10.288 0 5.145 5.145 0 0 1-5.144 5.145c-.022 0-.042-.007-.064-.007"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "matrix(1.33333 0 0 -1.33333 -1577.323 572.538)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1230.776 405.431c0-.691.141-1.348.388-1.95h-18.803a1.597 1.597 0 1 1 0-3.195h23.431c.022 0 .043.005.065.007.021 0 .042-.007.064-.007a5.145 5.145 0 0 1 0 10.29 5.146 5.146 0 0 1-5.145-5.145"
  })))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "sun"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(40.91009 -40.91009) rotate(-45 -.164 -31.228)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "scale(40.91009 -40.91009) rotate(-45 -.164 -31.228)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.401 393.404c0-11.296 9.157-20.454 20.455-20.454 11.297 0 20.455 9.158 20.455 20.454 0 11.298-9.158 20.456-20.455 20.456-11.298 0-20.455-9.158-20.455-20.456"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "matrix(1.33333 0 0 -1.33333 -1173.141 572.54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M895.401 393.404c0-11.296 9.157-20.454 20.455-20.454 11.297 0 20.455 9.158 20.455 20.454 0 11.298-9.158 20.456-20.455 20.456-11.298 0-20.455-9.158-20.455-20.456"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M.004.001h96v96h-96z",
    paintOrder: "stroke fill markers"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "snowthunder"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 12.798 -57.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2eef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 1,
    gradientTransform: "scale(28.74394 -28.74394) rotate(-45 -7.652 -26.119)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 437.972 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 465.884 364.871)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x2: 1,
    gradientTransform: "matrix(9.66123 0 0 -9.66123 452.41 357.883)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x2: 1,
    gradientTransform: "scale(27.16368 -27.16368) rotate(-45 12.798 -57.24)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 943.388h1828.656V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1208.592 229.026l-5.267-9.123c-.825-1.428-.154-2.499 1.492-2.378l4.302.315c1.646.122 2.348-.965 1.56-2.415l-4.785-8.806c-.788-1.45-.39-1.778.884-.73l17.302 14.229c1.274 1.048.968 1.836-.679 1.752l-6.612-.338c-1.647-.084-2.32 1.016-1.496 2.445l2.91 5.04c.825 1.428.15 2.598-1.5 2.601h-3.611c-1.65 0-3.676-1.166-4.5-2.594"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(1.33333 0 0 -1.33333 -1554.56 355.264)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1208.592 229.026l-5.267-9.123c-.825-1.428-.154-2.499 1.492-2.378l4.302.315c1.646.122 2.348-.965 1.56-2.415l-4.785-8.806c-.788-1.45-.39-1.778.884-.73l17.302 14.229c1.274 1.048.968 1.836-.679 1.752l-6.612-.338c-1.647-.084-2.32 1.016-1.496 2.445l2.91 5.04c.825 1.428.15 2.598-1.5 2.601l-3.611.002c-1.65.002-3.676-1.166-4.5-2.594"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M473.696 377.985c5.89 0 10.664 4.774 10.664 10.664s-4.774 10.664-10.664 10.664c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085 0-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.2 0-7.289 5.91-13.198 13.198-13.198"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "matrix(1.33333 0 0 -1.33333 -575.403 556.494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "matrix(1.33333 0 0 -1.33333 -588.62 556.494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "matrix(1.33333 0 0 -1.33333 -582.653 561.178)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 1 1-9.662 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-.003h96v96H0z",
    paintOrder: "stroke fill markers"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteSheet);
export default __webpack_public_path__ + "static/media/sprite-sheet.0a54b609f31fcb1df4628dae36824c5f.svg";
export { ForwardRef as ReactComponent };